import React from 'react';
import './fileSearch.css';
import { Input, Icon,message} from 'antd';
import 'antd/dist/antd.css';
import FileDirectory from './fileDirectory'
import FileList from './fileList'

import File_Icon_Test from '../imageSrc/wenjianjia.png';
import File_Upload from '../imageSrc/fileUpload.png';
import New_Dir from '../imageSrc/newDir.png'
import '../utils/fetchData'
import {fetchGet, fetchPost} from "../utils/fetchData";
import {Modal} from 'antd'
import '../utils/fetchData'
import {convert_FormData_to_json2} from "../../config";
import File_Empty from './emptyFile'
import Table_Header from './tableHeader'
import {showErrorMsg} from "../utils/commonFunc";

const { Search } = Input;

class FileSearch extends React.Component {
    constructor(props) {
        super(props);
        this.fileTitle=null;
        this.state = {
            directory:['全部文件'],                                          //所有目录
            fileObj : [],        //总目录
            currentDir : [],              //当前的目录
            modalVisible:false,
            dirIds:['root'],
            submitFileNameToNewOrRename:'new',    //提交文件夹名称用来新建文件夹还是重命名
            fileIdWithRename:null,                //需要重命名的fileid
            searchText:null,                      //搜索的关键字
            isInSearchState:false,                //是否在搜索界面
            empty_file_visible:false,             //是否展示空文件页面
            empty_type:null,                      //是文件加页面为空还是搜索为空
        }
    }
    searchVisible = ()=> {
        return this.props.visible?'block':'none';
    };

    componentDidMount() {
        this.props.triggerRef(this)
        this.getDirectoryWithId('root',this.state.directory,false);
    }

    updataFile = () => {
        this.getDirectoryWithId('root',this.state.directory,false);
    };

    getDirectoryWithId = (dirId,dirGroup,isRefresh) => {
        let params = {directory_id:dirId,page:'1',size:20};
        let dirIdsTemp = this.state.dirIds;
        if (this.state.isInSearchState) {
            dirIdsTemp.pop();
        }
        dirIdsTemp.push(dirId);
        let data = fetchGet('directory',params,null);
        data.then(data => {
            if (data.code === 200) {
                let latestObj = this.state.fileObj;
                if (this.state.isInSearchState) {
                    latestObj.pop();
                }
                if (isRefresh) {
                    let depth = latestObj.length;
                    latestObj[depth - 1] = data.data.page_data;
                } else {
                    latestObj.push(data.data.page_data);
                }
                this.setState({
                    fileObj:latestObj,
                    currentDir:data.data.page_data,
                    directory:dirGroup,
                    dirIds:dirIdsTemp,
                    isInSearchState:false,
                });

                if (data.data.page_data.length === 0) {
                    this.setState({
                        empty_file_visible:true,
                        empty_type:'dir',
                    });
                } else {
                    this.setState({
                        empty_file_visible:false,
                        empty_type:null,
                    });
                }
            } else {
                showErrorMsg(data);
                if (data.code === 402) {
                    window.history.back(-1);
                }

            }
        })
    };

    handleItemClick = (fileName,fileId,fileType) => {
        if (fileType === 1) {
            let newDirectoryName = fileName;
            let latestDirectoryName = this.state.directory;
            if (this.state.isInSearchState) {
                latestDirectoryName.pop();
            }

            latestDirectoryName.push(newDirectoryName);
            this.getDirectoryWithId(fileId,latestDirectoryName,false);
        } else {
            this.fileTitle=fileName;
            this.handleGetFileContent(fileId);
        }

    };

    handleClickDir = (index) => {
        let nowFileObj = this.state.fileObj.slice(0,index + 1);
        let nowLatestDir = nowFileObj[index];
        this.setState({
            directory:this.state.directory.slice(0,index + 1),
            fileObj:nowFileObj,
            currentDir:nowLatestDir,
            dirIds:this.state.dirIds.slice(0,index + 1),
            isInSearchState:false,
        })
        if (nowLatestDir.length === 0) {
            this.setState({
                empty_file_visible:true,
                empty_type:'search',
            });
        } else {
            this.setState({
                empty_file_visible:false,
                empty_type:null,
            });
        }

    };

    ///// upload file
    upLoadFile = ()=>{
        document.getElementById('doc-file').click();
    };

    realUpLoadFile = ()=> {
        let file = this.refs.fileUpload.files[0];


        let that = this;
        let dirIdsLength = this.state.dirIds.length;
        let formDataUpload = new FormData();
        formDataUpload.append("file", file);
        formDataUpload.append("directory_id", this.state.dirIds[dirIdsLength - 1]);


        let header = new Headers({
            'Accept': 'application/json',
        });
        if (localStorage.getItem('loginusertoken') != null) {
            header.append('loginusertoken',localStorage.getItem('loginusertoken'));
        }
        if (localStorage.getItem('authentication') != null) {
            header.append('authentication','TOKEN ' + localStorage.getItem('authentication'));
        }
        let retValue = fetchPost('uploadfile',formDataUpload,header);
        retValue.then(data => {
            if (data.code === 200) {
                this.getDirectoryWithId(this.state.dirIds[dirIdsLength - 1],this.state.directory,true);
                message.success('上传成功');
                that.setState({
                    loginStyle:'sms_code',
                    serialNo:data.data.seria_no,
                })
            }
            else {
                showErrorMsg(data);
            }
        })

    };

    ///// upload file end

    showMakeNewFile = () => {
        if (!this.state.isInSearchState) {
            this.setState({
                modalVisible:true,
                submitFileNameToNewOrRename:'new',
            })
        } else {
            message.error('搜索状态下不能创建文件');
        }
    };

    handleModalCancel = () => {
        this.setState({
            modalVisible:false,
        })
    };

    ////回车键搜索
    searchFileWithkeyWord = (searchText) => {
        let params = {key:searchText,page:'1',size:20};
        let data = fetchGet('searchFile',params,null);
        data.then(data => {
            if (data.code === 200) {
                let firstFile = [];
                firstFile.push(this.state.fileObj[0]);
                firstFile.push(data.data.page_data);

                let firstDir = [];
                firstDir.push(this.state.directory[0]);
                firstDir.push('搜索' + '"' + searchText + '"');

                let firstDirId = [];
                firstDirId.push(this.state.dirIds[0]);
                firstDirId.push('temp');
                this.setState({
                    fileObj:firstFile,
                    currentDir:data.data.page_data,
                    directory:firstDir,
                    dirIds:firstDirId,
                    isInSearchState:true,
                })

                if (data.data.page_data.length === 0) {
                    this.setState({
                        empty_file_visible:true,
                        empty_type:'search',
                    });
                } else {
                    this.setState({
                        empty_file_visible:false,
                        empty_type:null,
                    });
                }
            } else {
                showErrorMsg(data);
            }
        })
    };

    handleEnterKey = (event) => {
        let search_text = event.target.value;
        if(!search_text){
            message.error('请输入搜索内容后再点击搜索按钮');
            return false;
        }
        this.setState({
            searchText:search_text,
        });
        this.searchFileWithkeyWord(search_text);
    };

    ////重命名或新建文件夹
    handleSubmitFileName = ()=> {
        if (this.state.submitFileNameToNewOrRename === 'new') {
            this.createNewFileDir();
        } else {
            this.handleRenameFileWithRequest(this.state.fileIdWithRename);
        }
    };

    createNewFileDir = () => {
        let dirIdsLength = this.state.dirIds.length;
        let fileName = this.refs.model.value;
        let fileId = this.state.dirIds[dirIdsLength - 1];

        let formData = new FormData();
        formData.append("directory_id", fileId);
        formData.append("file_name", fileName);

        let that = this;

        let retValue = fetchPost('makeDirectory',convert_FormData_to_json2(formData),null);
        retValue.then(data => {
            if (data.code === 200) {
                message.success('创建成功');
                that.handleModalCancel();
                that.getDirectoryWithId(fileId,that.state.directory,true);
            }
            else {
                showErrorMsg(data);
            }
        })
    };

    //////删除文件夹
    handleDeleteFileDoc = (fileId) => {
        let dirIdsLength = this.state.dirIds.length;
        let PDirId = this.state.dirIds[dirIdsLength - 1];

        let formData = new FormData();
        formData.append("file_id", fileId);

        let that = this;

        let retValue = fetchPost('rmFile',convert_FormData_to_json2(formData),null);
        retValue.then(data => {
            if (data.code === 200) {
                that.handleModalCancel();
                message.success('删除成功');
                if (!this.state.isInSearchState) {
                    that.getDirectoryWithId(PDirId,that.state.directory,true);
                } else {
                    this.searchFileWithkeyWord(this.state.searchText);
                }
            }
            else {
                showErrorMsg(data);
            }
        })
    };


    ////重命名文件
    handleRenameFileWithRequest = (fileId) => {
        let dirIdsLength = this.state.dirIds.length;
        let fileName = this.refs.model.value;
        let PDirId = this.state.dirIds[dirIdsLength - 1];

        let formData = new FormData();
        formData.append("file_id", fileId);
        formData.append("file_name", fileName);

        let that = this;

        let retValue = fetchPost('renameFile',convert_FormData_to_json2(formData),null);
        retValue.then(data => {
            if (data.code === 200) {
                that.handleModalCancel();
                if (!this.state.isInSearchState) {
                    that.getDirectoryWithId(PDirId,that.state.directory,true);
                } else {
                    this.searchFileWithkeyWord(this.state.searchText);
                }
            }
            else {
                showErrorMsg(data);
            }
        })
    };

    handleRenameFile = (fileId) => {
        this.setState({
            submitFileNameToNewOrRename:'rename',
            fileIdWithRename:fileId,
            modalVisible:true,
        })
    };

    handleGetFileContent = (fileid) => {
        let params = {file_id:fileid};

        let data = fetchGet('readFile',params,null);
        data.then(data => {
            if (data.code === 200) {
                this.props.handlePreviewFile(this.fileTitle, data.data.info,fileid);
            } else {
                showErrorMsg(data);
            }
        })
    };

    stopMaoPao = (e) => {
        e.stopPropagation();
        this.props.stopMaoPao(e);
    };

    render(){
        return(
            <div onClick={this.stopMaoPao} className='divFilePage_style' tabIndex='1'  style={{display:'inline',left:this.props.visible?0+'px':-96+'vw'}}>
                <p style={{display:'inline-block'}}>文件</p>
                <form style={{display:'none'}}  encType="multipart/form-data" action="/upload/image" method="post">
                    <input ref='fileUpload' id="doc-file" type="file" onChange={this.realUpLoadFile}/>
                </form>
                <img onClick={this.upLoadFile} className='left_image' src={File_Upload}/><img onClick={this.showMakeNewFile} className='right_image' src={New_Dir}/>
                <Modal
                    title="输入文件夹名称"
                    visible={this.state.modalVisible}
                    onOk={this.handleSubmitFileName}
                    onCancel={this.handleModalCancel}
                >
                    <input ref='model' style={{width : 100 + '%'}}/>
                </Modal>
                <Input onPressEnter={this.handleEnterKey} style={{marginLeft:5 + '%',width:88 + '%'}}
                    placeholder="输入文件名称"
                    prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)'}} />}
                />
                <FileDirectory directory={this.state.directory} handleClickDir={this.handleClickDir}/>
                <Table_Header/>
                <File_Empty visible={this.state.empty_file_visible} type={this.state.empty_type}/>
                <FileList currentDir={this.state.currentDir}
                          handleItemClick={this.handleItemClick}
                          handleDelete={this.handleDeleteFileDoc}
                          handleRenameFile={this.handleRenameFile}/>
            </div>
        );
    }
}

export default FileSearch